import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
  modal: {
    heading: null,
    open: null,
    data: {},
  },
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setModal: (state, {payload}) => ({
      ...state,
      modal: {
        ...state.modal,
        ...payload,
      },
    }),
    resetModal: state => ({
      ...state,
      modal: initialState.modal,
    }),
  },
});

export const profileState = state => state.profile;

export const {setModal, resetModal} = profileSlice.actions;

export default profileSlice.reducer;
